// profilePlaceholders.js

export const getProfilePlaceholder = (user, business) => {
  const defaultFirst = 'Associate';
  const defaultLast = 'Name';

  const fullName = user?.u_first_name?.trim() && user?.u_last_name?.trim()
    ? `${user.u_first_name} ${user.u_last_name}`
    : `${defaultFirst} ${defaultLast}`;

  const addressLine1 = business?.b_address?.trim() || 'Street Address';
  const city = business?.b_city?.trim() || 'City';
  const state = business?.b_state?.trim() || 'State';
  const zip = business?.b_zip_code?.trim() || 'Zip Code';

  const addressLine2 = `${city}, ${state} ${zip}`;

  return {
    name: fullName,
    jobTitle: user?.u_job_title?.trim() || 'Job Title',
    phoneNumber: user?.u_phone_number?.trim() || 'Mobile Number',
    businessPhone: business?.b_phone?.trim() || 'Business Phone',
    industry: business?.b_business_industry?.trim() || 'Industry',
    addressLine1,
    addressLine2
  };
};
